import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function UploadPaleomapBreadcrumbWrapper() {
  useBreadcrumb('routes/upload/paleomap', 'Palaeomaps');
  return <Outlet />;
}
